export const TIPOS_GRAFICO = [
    {id: 'cantidad', description: 'por cantidad vendida', porc_id: 'porc_cant'},
    {id: 'importe', description: 'por importe vendido', porc_id: 'porc_importe'}
]
